import request from "@/router/axios";
// 获取车次数据
export function getTrainListData(params) {
  return request({
    url: '/check/train/trainList/getTrainListData',
    method: 'get',
    params: params
  })
}
// 获取 addindex
export function getAddindex(params) {
  return request({
    url: '/check/train/trainList/carriageIndex',
    params: params
  })
}
// 按列车 ID 查询问题
export function queryProblemsByTrainId(params) {
  return request({
    url: '/check/train/problem/queryProblemsByTrainId',
    params: params
  })
}
// 查询车节列表
export function getCarriageList(params) {
  return request({
    url: '/check/train/detailList/all',
    method: 'get',
    params: params
  })
}
// 查询车厢异常列表
export function getProblemByTrainListDetailID(params) {
  return request({
    url: '/check/train/problem/getTrainProblemByTrainDetailId',
    method: 'get',
    params: params
  })
}
// 车厢异常删除
export function deleteProblem(params) {
  return request({
    url: '/check/train/problem/deleteProblem',
    method: 'post',
    params: params
  })
}

// 车厢异常处理
export function handleProblem(params) {
  return request({
    url: '/check/train/problem/handle',
    method: 'post',
    data: params
  })
}
// 下载车次导入模板
export function exportTrainTemplate(params) {
  return request({
    responseType: 'blob',
    url: '/check/train/detailList/export?name=火车车厢信息导入模板'
  })
}
// 车次导入
export function importTrainTemplate(params) {
  return request({
    url: '/check/train/detailList/import',
    method: 'post',
    data: params
  })
}
// 车次删除
export function trainListDelete(params) {
  return request({
    url: '/check/train/trainList/delete',
    method: 'post',
    params: params
  })
}
// 车厢删除
export function carriageDelete(params) {
  return request({
    url: '/check/train/detailList/delete',
    method: 'post',
    params: params
  })
}
// 获取新的车次数据
export function getNewPassingData() {
  return request({
    url: '/check/train/trainList/getNewPassingData'
  })
}



// 异常类型设置接口
export function checkUpdate(data) {
  return request({
    url: '/check/train/exceptions/check/update',
    method: 'post',
    data: data
  })
}
// 根据列车id获取问题统计
export function getStatistics(params) {
  return request({
    url: '/check/train/problem/statistics',
    method: 'get',
    params: params
  })
}

// 查询异常类型设置接口
export function getCheckData(params) {
  return request({
    url: '/check/train/exceptions/check/data',
    method: 'get',
    params: params
  })
}

// 查询统计详情信息
export function getStatisticsDetail(params) {
  return request({
    url: '/check/train/problem/statistics/detail',
    method: 'get',
    params: params
  })
}
// 查询异常信息详情信息
export function earlyWarning(params) {
  return request({
    url: '/check/train/problem/earlyWarning',
    method: 'get',
    params: params
  })
}
// 预警提报树状图接口
export function trainProblemTreeData(params) {
  return request({
    url: '/check/train/problem/trainProblemTreeData',
    method: 'get',
    params: params
  })
}

// 保存异常
export function earlyWarningSave(data) {
  return request({
    url: '/check/train/problem/earlyWarningSave',
    method: 'post',
    data: data
  })
}


// 调整亮度
export function updateLuminance(data) {
  return request({
    url: '/check/sys/option/update',
    method: 'post',
    data: data
  })
}


// 
export function orderOcrContainerDiffAlarm(params) {
  return request({
    url: '/check/train/trainList/orderOcrContainerDiffAlarm',
    method: 'get',
    params: params
  })
}
